<template>
  <div class="wrap">
    <div class="footer-wrap">
      <div class="left">
        <img src="../assets/logo.png" alt="logo" class="img" />
        <div class="item-row">飞碟科技(北京)地址：</div>
        <div class="item-row">北京市朝阳区望京SOHO-T2-B座220606室</div>
        <div class="item-row">
          电话：
          <span style="font-size: 28px; margin-right: 10px">010-64750508</span>
          <span style="font-size: 28px">13401162311</span>
        </div>
        <div class="item-row" style="margin-bottom: 28px">
          服务邮箱： service@uspacetech.com
        </div>
        <div class="item-row">飞碟科技(杭州)地址：</div>
        <div class="item-row">
          浙江省杭州市萧山区盈丰街道帆影路150号奥景名邸2幢602室-2
        </div>
        <div class="item-row">
          电话：<span style="font-size: 28px">15305812915</span>
        </div>
        <div class="item-row">服务邮箱： 15305812915@189.cn</div>
      </div>
      <!-- center -->
      <div class="center">
        <ul class="global-ul main-ul">
          <li
            class="main-item"
            v-for="(item, index) in linkList"
            :key="index"
            @click="handleTo(item.value)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="sub-ul-wrap">
          <ul class="global-ul">
            <li
              class="sub-item"
              v-for="(item, index) in linkToIndex"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
          <ul class="global-ul">
            <li
              class="sub-item"
              v-for="(item, index) in linkToCompany"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
          <ul class="global-ul">
            <li
              class="sub-item"
              v-for="(item, index) in linkToProduct"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
          <ul class="global-ul">
            <li class="sub-item"></li>
          </ul>
          <ul class="global-ul">
            <li
              class="sub-item"
              v-for="(item, index) in linkToNews"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <img
          src="../assets/qr.png"
          alt="img"
          style="width: 117px; margin-top: 68px"
        />
        <div style="text-align: center; margin-top: 16px">关注公众号</div>
      </div>
    </div>
    <div
      style="
        width: 770px;
        border-top: 1px solid #bac6d9;
        height: 30px;
        margin: 0 auto;
        font-weight: 300;
        font-size: 12px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        padding-bottom: 32px;
      "
    >
      Copyright 2022 北京飞碟科技有限公司 京ICP备2022007876号
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: [
        { name: "首页", value: "index" },
        { name: "走进飞碟", value: "company" },
        { name: "信息化系统", value: "product" },
        { name: "成功案例", value: "case" },
        { name: "新闻动态", value: "news" },
        { name: "联系我们", value: "contact" },
      ],
      // link to index
      linkToIndex: [
        { name: "走进飞碟", value: "" },
        { name: "信息化系统", value: "" },
        { name: "成功案例", value: "" },
        { name: "新闻动态", value: "" },
      ],
      //   link to company
      linkToCompany: [
        { name: "公司介绍", value: "" },
        { name: "资质荣誉", value: "" },
      ],
      // link to product
      linkToProduct: [
        { name: "信息软件服务", value: "" },
        { name: "运营管理服务", value: "" },
        { name: "售后服务", value: "" },
      ],
      //
      linkToNews: [
        { name: "企业新闻", value: "" },
        { name: "行业动态", value: "" },
      ],
    };
  },
  methods: {
    handleTo(value) {
      if (value === "case") {
        if (this.curRouter !== "index") {
          this.$router.push(value);
          setTimeout(() => {
            scrollTo({
              top: document.getElementById("case").getBoundingClientRect().top,
            });
          }, 200);
        } else {
          scrollTo({
            top: document.getElementById("case").getBoundingClientRect().top,
          });
        }
      }
      if (value === "product") {
        this.$router.push({ path: `/${value}`, query: { type: "1" } });
      } else {
        this.$router.push(`/${value}`);
      }
      window.scrollTo({ top: 0 });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background-color: #125497;
  overflow: hidden;
  .footer-wrap {
    width: 1200px;
    margin: 74px auto 25px;
    display: flex;
    color: #fff;
  }
}
.img {
  width: 284px;
  margin-bottom: 28px;
}
// left
.left {
  padding-right: 40px;
  position: relative;
}
.left::after {
  content: "";
  width: 1px;
  height: 194px;
  background: #fff;
  display: block;
  margin: 0;
  position: absolute;
  right: 0;
  top: 14px;
}
.phone-wrap {
  font-size: 16px;
  margin-bottom: 18px;
}
.phone-value {
  font-size: 32px;
}
.email {
  margin-bottom: 22px;
}
// center
.center {
  padding-left: 20px;
}
.global-ul {
  list-style-type: none;
  color: #fff;
  opacity: 0.6;
  font-size: 16px;
  font-weight: 400;
  padding: 0;
}
.main-ul {
  display: flex;
}
.main-item {
  width: 102px;
  cursor: pointer;
  text-align: left;
}
.main-item:hover {
  color: #fff;
}
.sub-ul-wrap {
  display: flex;
}
.sub-item {
  width: 102px;
  text-align: left;
  margin-bottom: 20px;
  font-size: 12px;
}

.item-row {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}
</style>
